export const slider = () => {
    const sliderCard = document.querySelector(".slider__card")

    if (sliderCard) {
        const sliderCardButtons = document.querySelectorAll(".slider__button")

        let isDragging = false
        let startX = 0
        let startScrollLeft = 0

        const cardWidth = 280 // whidth of a card
        sliderCard.scrollLeft = 0 // position of a frame
        let kardWidthCouter = 0

        const step = 4 // step for buttons clicking

        // navigation of left/right buttons
        sliderCardButtons.forEach((button) => {
            button.addEventListener("click", (e) => {
                e.preventDefault()

                // clicking a right button
                if (button.id === "right-slider-button") {
                    sliderCard.classList.add("grabbing")
                    let n = 0
                    let interval = setInterval(() => {
                        n += step
                        sliderCard.scrollLeft += step
                        if (n >= cardWidth) {
                            clearInterval(interval)
                            kardWidthCouter += cardWidth
                            sliderCard.classList.remove("grabbing")
                        }
                    })

                    // >= end a frame
                    if (kardWidthCouter >= cardWidth * 7) {
                        sliderCard.scrollLeft = cardWidth * 7
                        kardWidthCouter = cardWidth * 7
                    }
                }

                // clicking a left button
                if (button.id === "left-slider-button") {
                    sliderCard.classList.add("grabbing")
                    let n = 0
                    let interval = setInterval(() => {
                        n += step
                        sliderCard.scrollLeft += -step
                        if (n >= cardWidth) {
                            clearInterval(interval)
                            kardWidthCouter += -cardWidth
                            sliderCard.classList.remove("grabbing")
                        }
                    })

                    // <= start a frame
                    if (kardWidthCouter <= 0) {
                        sliderCard.scrollLeft = 0
                        kardWidthCouter = 0
                    }
                }
            })
        })

        // the mouse is dragging
        sliderCard.addEventListener("mousedown", (e) => {
            isDragging = true
            e.preventDefault()
            sliderCard.classList.add("grabbing")
            startX = e.pageX - sliderCard.offsetLeft
            startScrollLeft = sliderCard.scrollLeft
        })
        // the touch stops dragging
        sliderCard.addEventListener(
            "touchstart",
            (e) => {
                isDragging = true
                sliderCard.classList.add("grabbing")
                startX = e.touches[0].clientX - sliderCard.offsetLeft
                startScrollLeft = sliderCard.scrollLeft
            },
            { passive: true }
        )

        // the mouse is outside a slider
        sliderCard.addEventListener("mouseleave", () => {
            isDragging = false
            sliderCard.classList.remove("grabbing")
        })

        // the mouse stops dragging
        sliderCard.addEventListener("mouseup", () => {
            isDragging = false
            sliderCard.classList.remove("grabbing")
        })
        // the touch stops dragging
        sliderCard.addEventListener(
            "touchend",
            () => {
                isDragging = false
                sliderCard.classList.remove("grabbing")
            },
            { passive: true }
        )

        // the mouse moves dragging
        sliderCard.addEventListener("mousemove", (e) => {
            if (!isDragging) return
            e.preventDefault()
            const x = e.pageX - sliderCard.offsetLeft
            const walk = (x - startX) * 1.5 //scroll fast
            kardWidthCouter = startScrollLeft - walk
            sliderCard.scrollLeft = startScrollLeft - walk
        })
        // the touch moves dragging
        sliderCard.addEventListener(
            "touchmove",
            (e) => {
                if (!isDragging) return
                const x = e.touches[0].clientX - sliderCard.offsetLeft
                const walk = (x - startX) * 1.5 //scroll fast
                kardWidthCouter = startScrollLeft - walk
                sliderCard.scrollLeft = startScrollLeft - walk
            },
            { passive: true }
        )
    }
}
